// src/component/ui/AnimSettings.jsx
// Contrôle d'intensité des animations (Élevé / Réduit / Désactivé), persisté en localStorage.
import React, { useState } from "react";
import "./animSettings.css";

const LEVELS = [
  { v: "high", l: "Élevé" },
  { v: "low", l: "Réduit" },
  { v: "off", l: "Désactivé" },
];

export default function AnimSettings() {
  const [level, setLevel] = useState(() => {
    try { return localStorage.getItem("animLevel") || "high"; } catch { return "high"; }
  });
  const set = (v) => {
    setLevel(v);
    try { localStorage.setItem("animLevel", v); } catch {}
    document.documentElement.dataset.anim = v;
  };
  return (
    <div className="anim-settings">
      <span className="anim-settings__label">Animations du site</span>
      <div className="anim-settings__group" role="group" aria-label="Intensité des animations">
        {LEVELS.map((o) => (
          <button
            key={o.v}
            type="button"
            className={"anim-settings__btn" + (level === o.v ? " is-active" : "")}
            onClick={() => set(o.v)}
          >
            {o.l}
          </button>
        ))}
      </div>
    </div>
  );
}
